import { createSelector } from "reselect";

export const blogListSelector = (state) => state.blog.blogList;
const paramsSelector = (state) => state.blog.params;

export const allBlogParamsSelector = createSelector(
    paramsSelector,
    (blog) => blog.blogParams
);
